var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.currentStatus == 1 || _vm.currentStatus == 0)?_c('div',{staticClass:"status-circle d-inline-block",class:(_vm.currentStatus == 1)? 'connected' : 'disconnected'}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }